export const blockIconsMapsFlight = (
	<span className='material-symbols-outlined'>flight</span>
);
